import { ValidationFieldKey } from 'shared/constants/payment'

export type rolesType = 'P' | 'AG' | 'C' | 'A' | 'SA' | 'O' | 'SO'

export type TransactionStatusesType = 'OPEN' | 'IN_PROCESS' | 'COMPLETED' | 'REJECTED' | 'ALL'

export type PaymentListStatusesType = 10 | 20 | 21 | 22 | 27 | 30 | 40

export type transactionStatusesType =
  | 'Success'
  | 'Started'
  | 'Failed'
  | 'Canceled'
  | 'ManualApprovingRequired'
  | 'Approving'
  | 'ApprovingSuccess'
  | 'ApprovingFailed'
  | 'ManualProcessRequired'
  | 'Frozen'
  | 'Expired'

export enum DocumentTypes {
  PASSPORT = 'P',
  DRIVER_LICENSE = 'DL',
  NATIONAL_ID = 'ID',
}

export const PaymentTypes = {
  DEPOSIT: 'deposit',
  PAYOUT: 'payout',
} as const

export const PaymentSystemNames = {
  PAGSTAR: 'pagstar',
  NOWPAYMENTS: 'nowpayments',
  ETHERONE: 'etherone',
  CODETECH: 'codetech',
  SUITPAY: 'suitpay',
  FIVERT: 'fivert',
  INTERNAL: 'internal',
  MOBCASH: 'mobcash',
} as const

export const PaymentMethods = {
  CARD: 'card',
  CRYPTO: 'crypto',
  PIX: 'pix',
  CASH: 'cash',
  MOBCASH: 'mobcash',
} as const

export type TransactionType = 'withdrawal' | 'deposit'

export const DepositResponseNames = {
  QR: 'qr',
  URL: 'url',
  WALLET_ADDRESS: 'wallet_address',
  EMPTY: 'empty',
} as const

export const FieldTypes = {
  INPUT: 'input',
  SELECTOR: 'selector',
  DATE: 'date',
  HIDDEN: 'hidden',
} as const

export type FieldTypesType = ReverseMap<typeof FieldTypes>

export type PaymentSystemNamesType = ReverseMap<typeof PaymentSystemNames>

export type PaymentMethodsType = ReverseMap<typeof PaymentMethods>

export type DepositResponseType = ReverseMap<typeof DepositResponseNames>

export type PaymentTypesType = ReverseMap<typeof PaymentTypes>

export type PaymentValidationType = ReverseMap<typeof ValidationFieldKey>
